import {
  Save as SaveIcon
} from '@mui/icons-material';
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Divider,
  CircularProgress
} from '@mui/material';
import { Row, Col } from 'antd';
import React from 'react';

// OrderSummaryProps arayüzüne KDV ve indirim toplamları ekleyelim
interface OrderSummaryProps {
  totalAmount: number;
  netTotal: number; // Net toplam (indirim sonrası)
  taxTotal: number; // KDV toplamı
  description: string;
  onDescriptionChange: (value: string) => void;
  onSave: () => void;
  saving: boolean;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({
  totalAmount,
  netTotal, // Eksik prop'ları ekleyelim
  taxTotal, // Eksik prop'ları ekleyelim
  description,
  onDescriptionChange,
  onSave,
  saving
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY'
    }).format(amount);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Sipariş Özeti
      </Typography>
      
      <Row gutter={[24, 24]}>
        <Col xs={24} md={16}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="subtitle1" gutterBottom>
              Açıklama
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={6}
              value={description}
              onChange={(e) => onDescriptionChange(e.target.value)}
              placeholder="Sipariş ile ilgili açıklamalar..."
              variant="outlined"
            />
          </Paper>
        </Col>
        
        <Col xs={24} md={8}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="subtitle1" gutterBottom>
              Tutar Bilgileri
            </Typography>
            
            // Tutar bilgileri bölümünü güncelleyelim
            <Box sx={{ mb: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="body2">Ara Toplam:</Typography>
                <Typography variant="body2">{formatCurrency(netTotal)}</Typography>
              </Box>
              
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="body2">KDV:</Typography>
                <Typography variant="body2">{formatCurrency(taxTotal)}</Typography>
              </Box>
              
              <Divider sx={{ my: 1 }} />
              
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="h6" fontWeight="bold">Genel Toplam:</Typography>
                <Typography variant="h6" fontWeight="bold" color="primary">
                  {formatCurrency(totalAmount)}
                </Typography>
              </Box>
            </Box>
            
            <Button
              fullWidth
              variant="contained"
              size="large"
              startIcon={saving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
              onClick={onSave}
              disabled={saving}
              sx={{ mt: 2 }}
            >
              {saving ? 'Kaydediliyor...' : 'Siparişi Kaydet'}
            </Button>
          </Paper>
        </Col>
      </Row>
    </Box>
  );
};

export default OrderSummary;